import React from 'react';

import Content from '@components/Dashboard/BenefitArea/PejotaPlus';

const PejotaPlus: React.FC = () => {
  return <Content />;
};

export default PejotaPlus;
